<div #container class="nc-liquid-chrome-canvas-container"></div>
<div class="nc-content-wrapper">
    <ng-content></ng-content>
</div>